import routes from '@config/routes';
import { UserRole } from 'types/enums';
import { getDashboardRoutePath } from 'utils/routes-util';
import { hasRoles } from 'utils/users-util';

import type { MainNavOptions } from './types';

export const MAIN_NAV = ({
  user: { defaultVendorId = '', roleStrings },
  profileNameId,
  isLoggedIn,
}: MainNavOptions) => {
  return [
    {
      hide:
        !isLoggedIn ||
        !hasRoles(roleStrings, [
          UserRole.Admin,
          UserRole.Manager,
          UserRole.Employee,
          UserRole.SuperAdmin,
          UserRole.Owner,
          UserRole.Accountant,
        ]),
      href: getDashboardRoutePath(
        routes.dashboard.overview,
        profileNameId || defaultVendorId
      ),
      label: 'Dashboard',
    },
    {
      hide: !hasRoles(roleStrings, [UserRole.Admin, UserRole.SuperAdmin]),
      href: 'https://admins.goodfynd.com',
      label: 'Admins Dashboard',
    },
  ].filter((item) => !item.hide);
};
